import React from "react";
import { useNavigate } from "react-router-dom";
import { AlertTriangle, ChevronRight } from "lucide-react";
import { useDevices } from "@/hooks/useDevices";
import {
  PageHeader, DataTable, EmptyState, DeviceStatusBadge, type Column,
} from "@/components/ui";
import type { DeviceSummary } from "@/api/devices";

// Org-wide alerts entry. Alert rules are configured per device; this lists the
// fleet and links into each device's alert configuration. (A future org-wide
// rules endpoint can replace this with an aggregated table.)
export function OrgAlerts() {
  const navigate = useNavigate();
  const { data, isLoading } = useDevices();
  const devices = data?.devices ?? [];

  const columns: Column<DeviceSummary>[] = [
    { key: "name", header: "Device", render: (d) => d.label ?? d.serial_number },
    { key: "model", header: "Model", render: (d) => d.model },
    { key: "status", header: "Status", render: (d) => <DeviceStatusBadge online={d.is_online} /> },
    {
      key: "go", header: "", align: "right",
      render: () => <ChevronRight size={16} className="text-textLight inline" />,
    },
  ];

  return (
    <div className="space-y-md">
      <PageHeader title="Alerts" subtitle="Alert rules per device" icon={AlertTriangle} />
      {!isLoading && devices.length === 0 ? (
        <EmptyState title="No devices" icon={AlertTriangle} />
      ) : (
        <DataTable
          columns={columns}
          rows={devices}
          getRowKey={(d) => d.id}
          loading={isLoading}
          onRowClick={(d) => navigate(`/devices/${d.id}/alerts`)}
        />
      )}
    </div>
  );
}

export default OrgAlerts;
